<template>

    <v-flex xs12>

        <div :class="['wrapper', {'blur': loadingLogin || wait}]">
            <!--Create user-->
            <account-sign-up-form
                    v-if="!user"
                    ref="basicSignUp"
                    v-on:before-send="beforeSend"
                    v-on:error="onError"
                    v-on:success="submit"
                    v-on:validation-change="onValidationChange"
                    submit-label="Enviar"
                    :disabled="disabled"
                    :facebook-login="facebookLogin"
                    auto-login
            >
                <template v-slot:append>
                    <slot name="append"></slot>
                </template>

            </account-sign-up-form>

            <!--Show user-->
            <user-form
                    v-else
                    ref="userForm"
                    :submit-fn="submit"
                    :user="user"
                    v-on:validation-change="onValidationChange"
                    hide-password
                    :simple="simple"
                    :readonly="user.is_data_complete"
                    :disabled="disabled"
            ></user-form>
        </div>

        <div class="overlay" v-if="loadingLogin || wait">
            <span class="subtitle">Un momento por favor...</span>
        </div>

    </v-flex>
</template>

<script>
    import AccountSignUpForm from './AccountSignUpForm.vue'
    import UserForm from './UserForm.vue'

    import {mapState} from 'vuex'

    export default{
        components: {AccountSignUpForm, UserForm},
        props: ['disabled', 'wait', 'readonly', 'simple', 'facebookLogin'],
        mounted(){
          this.user = this.currentUser
        },
        data(){
            return {
                loading: false,
                user: this.currentUser || null
            }
        },
        computed:{
            ...mapState(['currentUser', 'loadingLogin'])
        },
        methods:{
            beforeSend(){
                this.loading = true
                this.$emit('before-send')
            },
            onValidationChange(){

            },
            submit(user){

                var vm = this
                vm.beforeSend()

                vm.$nextTick(function(){
                    vm.loading = false
                    vm.$emit('success', user)
                    if(vm.currentUser){
                        vm.user = vm.currentUser
                    }
                })
            },
            onError(error){
                this.$emit('error', error)
            }
        },
        watch: {
            currentUser(user){
                if(this.loading) return
                this.user = user
            }
        }
    }
</script>

<style scoped>

    .overlay{
        position: absolute;
        top: 0;
        left:0;
        width:100%;
        height:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(255,255,255,.65);
    }
    .wrapper.blur{
        filter: blur(15px)
    }

    .mod-advice{
        background: rgba(255,255,255,.8);
        border-radius: 3px;
        font-size: .8em;
        border: 1px solid #e1e1e1;
    }
</style>